export default __webpack_public_path__ + "static/media/wi_10n_rain.6329780a.svg";